import { IBookingState } from './types';

export const ACTION_TYPES = {
  LOADING: 'booking/loading',
  ERROR: 'booking/error',
  SET_SEAT_OPTION: 'booking/set_seat_option',
  SET_SEATS: 'booking/set_seats',
  TIME_LIST_UPDATED: 'booking/TimeListUpdated',
  SEAT_LIST_UPDATED: 'booking/SeatListUpdated',
  SET_MENUS: 'booking/MenuListUpdated',
  SET_ACTIVE_STEP_INDEX: 'booking/set_active_step_index',
  TIME_SELECTED: 'booking/timeSelected',
  NUMBER_OF_PERSON_UPDATED: 'booking/NumberOfPersonUpdated',
  PRODUCT_MENU_SELECTED: 'booking/ProductMenuSelected',
  FORM_ERRORS: 'booking/form_errors',
  FORM_COMPLETE_STEP: 'booking/form_complete_step',
  FORM_MOVE_NEXT_STEP: 'booking/form_move_next_step',
  ORDER_HOLD: 'booking/hold',
  ORDER_ADD_GUEST_INFO: 'booking/add_guest_info',
  ORDER_ACCEPT_TERMS: 'booking/accept_terms',
  ORDER_PAYMENT: 'booking/payment',
  FORM_FILL_STEP2_DATA: 'booking/form_fill_step2_data',
  FORM_FILL: 'booking/form_fill_data',
  FORM_SUBMIT: 'booking/form_submit',
  REQUEST_AVAILABLE_TIME: 'booking/request_available_time',

  // giftcard related actions
  GIFTCODE_VALIDATE_REQUESTED: 'booking/giftcodeValidateRequested',
  GIFTCODE_VALIDATE_COMPLETED: 'booking/giftcodeValidateCompleted',
  GIFTCODE_REMOVE_REQUESTED: 'booking/giftcodeRemoveRequested',
  MENU_LIST_UPDATE: 'booking/menuListUpdated',
  BOOKING_HOLD_ID_UPDATED: 'booking/holdIdUpdated',
  COOP_CODE_VALIDATE_REQUESTED: 'booking/coopCodeValidateRequested',
};

// booking step ids
export const BOOKING_STEP1 = 0;
export const BOOKING_STEP2 = 1;
export const BOOKING_STEP3 = 2;
export const BOOKING_STEP4 = 3;

export const BookingInitialSate: IBookingState = {
  order: {
    hold_id: 0,
    order_id: 0,
    expire_at: '0',
    guest_id: 0,
    line_items: [],
    total: 0,
    giftcards: [],
  },
  loading: false,
  form_data: {
    0: {
      step: BOOKING_STEP1,
      data: {
        num_person: 0,
        time: '0',
        menus: {},
      },
      errors: {},
      complete: false,
    },
    1: {
      step: BOOKING_STEP2,
      data: {
        name: '',
        email: '',
        phone: '',
        is_subscribe: false,
        last_giftcode: '',
        coop_code: null,
        coop_zip: null,
        giftcodes: [],
      },
      errors: {},
      complete: false,
    },
    2: {
      step: BOOKING_STEP3,
      data: {},
      errors: {},
      complete: false,
    },
    3: {
      step: BOOKING_STEP4,
      data: {},
      errors: {},
      complete: false,
    },
  },
  seat_menu_options: [0],
  menus: {
    entities: {},
    result: [],
  },
  productId: 0,
  seats: {
    entities: {},
    result: [],
  },
  times: {
    entities: {},
    result: [],
  },
  activeStepIndex: 0,
  steps: {
    0: {
      id: 0,
      label: 'BOOK',
      route: 'step1',
    },
    1: {
      id: 1,
      label: 'INFO',
      route: 'step2',
    },
    2: {
      id: 2,
      label: 'TERMS',
      route: 'step3',
    },
    3: {
      id: 3,
      label: 'PAYMENT',
      route: 'step4',
    },
  },
};
